module.exports = __webpack_public_path__ + "img/Phone_LMS.d0b93f59.png";